import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Typography, Grid, Box } from '@mui/material';
import { CustomDateTimePicker } from '../../../../components/CustomDateTimePicker';
import { ValidationError } from '../ValidationError';

export const PromotionSchedule = ({ 
  formData, 
  onInputChange,
  dateErrors = {}
}) => {
  return (
    <Card sx={{ mb: 3, boxShadow: 2 }}>
      <CardContent>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 600, color: 'black' }}>
          Сроки проведения акции
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Box>
              <CustomDateTimePicker
                placeholder="Дата и время начала акции"
                value={formData.date_start}
                onChange={(date) => onInputChange('date_start', date)}
                required
                fullWidth
                showSeconds={false}
                error={!!dateErrors.date_start}
              />
              <ValidationError error={dateErrors.date_start} />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box>
              <CustomDateTimePicker
                placeholder="Дата и время окончания акции"
                value={formData.date_end}
                onChange={(date) => onInputChange('date_end', date)}
                required
                fullWidth
                showSeconds={false}
                error={!!dateErrors.date_end}
              />
              <ValidationError error={dateErrors.date_end} />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

PromotionSchedule.propTypes = {
  formData: PropTypes.object.isRequired,
  onInputChange: PropTypes.func.isRequired,
  dateErrors: PropTypes.object
};
